import * as d3 from 'd3-selection'

export default function (selection, ganttId, tree) {
  selection.each(function (data) {
     // This is a line we need to draw when the status of the foreground shape doesn't match the full shape.
    // ie. It's incomplete.
    // The line is used so the stroke matches the other border edges of the foreground shape
    var endLine = d3.select(this)
                    .selectAll('line.gantt-item-task-line')
                    .data(d => {
                      if (d.percentComplete === 1 || d.percentComplete === 0) {
                       // 0 or 100% complete, no need to show the vertical line to draw the stroke outline
                       return []
                      }
                      return [{
                        id: d.id,
                        clazz: d.state,
                        width: d._gantt.foregroundWidth + d._gantt.x
                      }]
                    })

    endLine.exit().remove()

    endLine.enter()
           .append('line')
             .merge(endLine)
             .attr('class', d => `gantt-item-task-line ${d.clazz}`)
             .attr('clip-path', d => `url(#gantt-${ganttId}-item-vertical-clip-path-${d.id})`)
             .attr('x1', d => d.width)
             .attr('x2', d => d.width)
             .attr('y1', 0)
             .attr('y2', tree.options.height)
  })
}
